/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';
import { ITabItemViewProps, TabItemType } from './conditional-tab-item';

const ConditionalTabItemView: React.FC<ITabItemViewProps> = (props: ITabItemViewProps) => {
    const { tabItemType, tabSlots, TabContentContainer, TabHeaderContainer, TabItemContent, tabHeader, onVisibilityChange } = props;

    switch (tabItemType) {
        case TabItemType.TabContent:
            return (
                <Module {...TabContentContainer}>
                    <Node {...TabItemContent}>
                        {tabSlots &&
                            tabSlots.tabItemContent &&
                            tabSlots.tabItemContent.length &&
                            _renderTabItemContent(tabSlots.tabItemContent, onVisibilityChange)}
                    </Node>
                </Module>
            );
        case TabItemType.TabHeader:
            return <Module {...TabHeaderContainer}>{tabHeader}</Module>;
        default:
            return null;
    }
};

const _renderTabItemContent = (
    items: React.ReactNode[],
    onVisibilityChange: (visibilityState: VisibilityState) => void
): JSX.Element | null => {
    return (
        <>
            {items && items.length > 0
                ? items.map((item: React.ReactNode, index: number) => {
                      return (
                          <React.Fragment key={index}>
                              {React.cloneElement(item as React.ReactElement, {
                                  onVisibilityChange
                              })}
                          </React.Fragment>
                      );
                  })
                : null}
        </>
    );
};
export default ConditionalTabItemView;
